import { Icon, BackSvg } from '@spritz-finance/ui'
import styled from 'styled-components'

export const BackButtonContainer = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    &:hover {
        cursor: pointer;
    }
`

export const BackButton = ({ onClick }: { onClick?: () => void }) => {
    return (
        <BackButtonContainer onClick={() => onClick?.()}>
            <Icon icon={BackSvg} size={24} />
        </BackButtonContainer>
    )
}
